import React, { useState } from "react";
import FlowDiagram from "./FlowDiagram";
import { showErrorPopup } from "./toasts/MessagePopup";
import initApp from "../utility/initApp";
import { clearAssigneeCache } from "../utility/assigneeCache";
import { closeAllDropdowns } from "../utility/dropdownState";
export default function DragDropProject({ widget }) {
  const [dragging, setDragging] = useState(false);
  const [projectInfo, setProjectInfo] = useState(null);

  const handleDrop = async (event) => {
    event.preventDefault();
    setDragging(false);

    const textData = event.dataTransfer.getData("text");

    try {
      const parsed = JSON.parse(textData);
      const item = parsed?.data?.items?.[0];

      if (item) {
        const SUPPORTED_TYPES = ["Project Space", "dsplan:Project"];
        const isSupported =
          SUPPORTED_TYPES.includes(item.objectType) ||
          String(item.objectId || "").includes("uuid:");

        if (!isSupported) {
          showErrorPopup(
            `Only Project Space or Team Project objects can be loaded. You dropped a "${item.objectType}".`,
            "Invalid Object Type"
          );
          return;
        }
       //Call 3DSpace APIs only for Project Space type
       if (item.objectType === "Project Space") {
         await initApp.get3DSpaceURL();
         await initApp.userCtxCollabspaces(widget);
       }
        setProjectInfo(item);
        widget.setTitle("" + item.displayName);
      } else {
        showErrorPopup("The dropped item is not a valid project object.", "Invalid Project Data");
      }
    } catch (e) {
      showErrorPopup("Failed to parse project data. Please ensure you are dropping a valid project item.", "Parse Error");
    }
  };

  return (
    <div style={{ width: "100%", height: "100%" }}>

      {/* BEFORE DROP → SHOW ONLY DROP AREA */}
      {!projectInfo && (
        <div
          onDragOver={(e) => e.preventDefault()}
          onDragEnter={(e) => { e.preventDefault(); setDragging(true); }}
          onDragLeave={() => setDragging(false)}
          onDrop={handleDrop}
          style={{

            width: "600px",
            maxWidth: "90%",
            height: "80px",
            borderRadius: "10px",
            border: dragging ? "2px dashed #075985" : "1px solid #93C5FD", // lighter border
            backgroundColor: dragging ? "#E0F2FE" : "#F8FAFC", // very light fill
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            fontSize: "16px",
            fontWeight: 600,
            color: "#075985", // text color from image
            boxShadow: "0 2px 8px rgba(0, 0, 0, 0.05)",
            transition: "all 0.3s ease",
            margin: "30px auto",
            cursor: "pointer",
            textAlign: "center",
          }}
        >
          <div style={{ fontSize: 15, fontWeight: 600, color: "#075985", marginBottom: 4 }}>
            Drop Project Here
          </div>
        </div>
      )}
      {projectInfo && (
        <FlowDiagram
          data={projectInfo}
          onFatalError={() => setProjectInfo(null)}
          onHome={() => {
            setProjectInfo(null);
            clearAssigneeCache();
            closeAllDropdowns();
            widget.setTitle("Network Diagram");
          }}
        />
      )}

    </div>
  );
}